import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { StreamService } from '@app/_services/masters/stream.service';
import { stream } from '@app/_models/stream';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LogService } from '../../../_shared/log.service'

@Component({
  selector: 'app-stream-master-edit',
  templateUrl: './stream-master-edit.component.html',
  styleUrls: ['./stream-master-edit.component.css']
})
export class StreamMasterEditComponent implements OnInit {

  docId: number;
  editStreamForm: FormGroup;
  stream: stream[];
  submitted = false;
  streamName: string;
  response: any;
  streamId: number;
  getresponse: any;
  strMessage:string;
  get f() { return this.editStreamForm.controls; }

  showModalBox: boolean = false;
  @ViewChild('showModalBox', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;

  constructor(private eventService: LogService, private formBuilder: FormBuilder, private streamService: StreamService,
    private modalService: NgbModal, config: NgbModalConfig) { }

  @Input() childMessage: stream[];

  
  ngOnInit(): void {
    console.log("childMessage" + this.childMessage);
    this.response = this.childMessage;
    this.streamName = this.response.streamName;
    this.streamId = this.response.id;
    this.editStreamForm = this.formBuilder.group({
      streamName: ['', Validators.required]
    });
  }

  updateStream() {
    this.submitted = true;

    if (this.editStreamForm.invalid) {
      return;
    }
    var v = new stream();
    v.streamName = this.streamName;
    v.id = this.streamId;
    this.streamService.updateStream(v)
      .subscribe((response) => {
        if (response) {
          this.getresponse = response;
          if (this.getresponse.respMessage == "Success") {
            this.strMessage="Stream Updated Successfully.";
            this.modalService.open(this.showModalBoxTemplate);
            var v = response;
          }
          else if (this.getresponse.respMessage == "Failure") {
            this.strMessage=this.getresponse.respData;
            this.modalService.open(this.showModalBoxTemplate);
            var v = response;
          }
        }
      },
        (err: any) => {
          var message = err;
        });
  }

  refresh(): void {
    this.modalService.dismissAll(this.showModalBoxTemplate);
    this.eventService.emit<string>('7');
  }
  goBack()
  {
    this.eventService.emit<string>('7');
  }
}
